var _classCallCheck = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/inherits");

// Generated by CoffeeScript 2.4.1
(function () {
  var XMLStringWriter, XMLWriterBase;
  XMLWriterBase = require('./XMLWriterBase'); // Prints XML nodes as plain text

  module.exports = XMLStringWriter =
  /*#__PURE__*/
  function (_XMLWriterBase) {
    "use strict";

    _inherits(XMLStringWriter, _XMLWriterBase);

    // Initializes a new instance of `XMLStringWriter`
    // `options.pretty` pretty prints the result
    // `options.indent` indentation string
    // `options.newline` newline sequence
    // `options.offset` a fixed number of indentations to add to every line
    // `options.allowEmpty` do not self close empty element tags
    // 'options.dontPrettyTextNodes' if any text is present in node, don't indent or LF
    // `options.spaceBeforeSlash` add a space before the closing slash of empty elements
    function XMLStringWriter(options) {
      _classCallCheck(this, XMLStringWriter);

      return _possibleConstructorReturn(this, _getPrototypeOf(XMLStringWriter).call(this, options));
    }

    _createClass(XMLStringWriter, [{
      key: "document",
      value: function document(doc, options) {
        var child, i, len, r, ref;
        options = this.filterOptions(options);
        r = '';
        ref = doc.children;

        for (i = 0, len = ref.length; i < len; i++) {
          child = ref[i];
          r += this.writeChildNode(child, options, 0);
        } // remove trailing newline


        if (options.pretty && r.slice(-options.newline.length) === options.newline) {
          r = r.slice(0, -options.newline.length);
        }

        return r;
      }
    }]);

    return XMLStringWriter;
  }(XMLWriterBase);
}).call(this);